import React, { useEffect, useState } from "react";
import LeaveTakenTable from "./components/table/LeaveTakenTable";

import Statistics from "./components/Statistics";
import { toast } from "@/hooks/use-toast";

function StaffDashboardPage() {

  return (
    <div className="flex flex-col w-full h-screen p-4 gap-4">
      <Statistics />
      {/* </div> */}

      <div className="overflow-auto flex-grow flex">
        <LeaveTakenTable
        />
      </div>
    </div>
  );
}

export default StaffDashboardPage;
